import styled from 'styled-components';

export const SectionTitle = styled.div`
    color: ${(props) => props.theme.colors.sectionTitle};
    font-size: ${(props) => props.theme.fontSizes.sectionTitle};
    font-weight: bold;
    letter-spacing: 0;
    line-height: 19px;
`;
